import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  container({ container_id }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/container/${container_id}`
    );
  },
  fetchPackingHouseProcess({packing_house_process_id}) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/upload_packing_list/fetch_packing_house_process/" + packing_house_process_id
    );
  },
  uploadPackingList(container_id, file) {
    return RequesterV1.post(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${container_id}`,
      file
    );
  },
  downloadFormatXlsx(container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/download_format_xlsx/${container_id}`,
      { responseType: "blob" }
    );
  },
  fetchFormatHeaders(container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/fetch_format_headers/${container_id}`
    );
  }
};
